import { useNavigate, useRouteError } from "react-router-dom";
import { t } from "i18next";
import { useEffect } from "react";

export default function ErrorPage() {
  const error = useRouteError();
  const navigate = useNavigate();

  useEffect(() => {
    if (error?.status === 404) {
      setTimeout(() => {
        navigate(-1);
      }, 800);
    }
  }, [error, navigate]);

  return (
    <div id="error-page">
      <h1>Oops!</h1>
      <p>{t("404NotFound")}</p>
    </div>
  );
}
